export const TripsTranslationsDictionary =
{
    Business: "Business",
    Personal: "Personal",
    Uncategorized: "Uncategorized",
    BannerText: "You have uncategorized trips",
    GoToLatest: "Go to latest",
    Start: "Start",
    End: "End",
    Vehicle: "Vehicle",
    PleaseSelect: "Please Select",
    Annotation: "Annotation",
    EditAnnotation: "Edit Annotation",
    PreviousDay: "Previous day",
    NextDay: "Next day",
    Save: "Save",
    Cancel: "Cancel",
    Refresh: "Refresh",
    FailedToLoadTrips: "Failed to load trips",
    NoTripsToDisplay: "No trips to display",
    AnnotationError: "An annotation is required when categorizing a trip.",
    LoadingTrips: "Loading trips...",
    NeedsAttention: "Action required"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in TripsTranslationsDictionary) {
        r.push(TripsTranslationsDictionary[prop]);
    }
    return r;
};

export const TripsTranslations = getTranslations();